import Slider from '../services/sliderService';

export default function newsRelatedSlider() {
    const elements = document.querySelectorAll('.js-news-related-slider');

    function createReviewSlider(element, navigation) {
        const options = {
            slideVisibleClass: 'news-related-slider__slider-item--visible',
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1044: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
            navigation,
        };

        new Slider(element, options); // eslint-disable-line no-new
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.news-related-slider');

        createReviewSlider(element, {
            prevEl: wrapper.querySelector('.js-news-related-slider-previous'),
            nextEl: wrapper.querySelector('.js-news-related-slider-next'),
        });
    });
}
